export const DETAILS_SET = 'DETAILS_SET';
export const detailsSet = (data) => ({ type: DETAILS_SET, payload: data });

export const DETAILS_SET_PREMIUM = 'DETAILS_SET_PREMIUM';
export const detailsSetPremium = (isPremium) => ({ type: DETAILS_SET_PREMIUM, payload: isPremium });

export const DETAILS_SET_SHARED_AS = 'DETAILS_SET_SHARED_AS';
export const detailsSetSharedAs = (id) => ({ type: DETAILS_SET_SHARED_AS, payload: id });
